var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03042 3.48352C1.80818 2.48343 2.84592 1.67318 3.76226 2.13135L20.5973 10.4343C20.8332 10.5522 20.9871 10.7882 21 11.0516C21.0129 11.315 20.8826 11.5649 20.6593 11.7053L4.3546 21.8099C3.45015 22.3784 2.30453 21.5887 2.51404 20.5412L3.75212 14.3508C3.83119 13.9554 4.21578 13.699 4.61113 13.7781C5.00647 13.8572 5.26287 14.2418 5.1838 14.6371L4.0567 20.2726L18.7836 11.1598L3.56659 3.66587L5.01121 10.1668C5.03595 10.2781 5.13471 10.3574 5.24876 10.3574L9.62953 10.3572C10.0327 10.3572 10.3596 10.684 10.3596 11.0872C10.3596 11.4904 10.0328 11.8172 9.62959 11.8172L5.24882 11.8174C4.45042 11.8174 3.75914 11.2629 3.58594 10.4835L2.03042 3.48352Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic_send.9d73069bdf61ec597b66516e8d933da3.svg";
export { ForwardRef as ReactComponent };